var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-result flex column p-4",on:{"click":_vm.goLink}},[_c('div',{staticClass:"inner-container flex p-20 align-center gap-10"},[_c('div',{staticClass:"desc flex column"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.data?.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }